/*eslint-disable*/

/*
Array.last()
Agrega la función "last()" a cualquier array para obtener el último elemento
*/
if (!Array.prototype.last) {
  Array.prototype.last = function () {
    return this[this.length - 1];
  };
}

/*
Array.isEmpty()
Agrega la función "isEmpty()" a cualquier array verificar si contiene elementos
*/
if (!Array.prototype.isEmpty) {
  Array.prototype.isEmpty = function () {
    return this.length == 0;
  };
}

/*
Array.toTitleCase()
Agrega la función "toTitleCase()" que da formato a un String capitalizando la primer leta de cada palabra.
Ejemplo: "FACTURAS SIN PAGAR" o "facturas sin pagar" -> "Facturas Sin Pagar"
*/
if (!String.prototype.toTitleCase) {
  String.prototype.toTitleCase = function () {
    return this.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  };
}

/*
Array.isBlank()
Agrega la función "isBlank()" que valida que el String esté vacío y/o sin espacios en blanco únicamente.
*/
if (!String.prototype.isBlank) {
  String.prototype.isBlank = function () {
    return !this || /^\s*$/.test(this);
  };
}

if (!Array.prototype.groupBy) {
  Array.prototype.groupBy = function (key, showKey = false) {
    if (this.length == 0) return [];

    const dataByKey = this.reduce((groupedData, singleElement) => {
      groupedData[singleElement[key]] = [...(groupedData[singleElement[key]] || []), singleElement];
      return groupedData;
    }, {});

    return showKey ? dataByKey : Object.values(dataByKey);
  };
}

if (!Array.prototype.partition) {
  Array.prototype.partition = function partition(isValid) {
    return this.reduce(
      ([pass, fail], elem) => {
        return isValid(elem) ? [[...pass, elem], fail] : [pass, [...fail, elem]];
      },
      [[], []]
    );
  };
}

if (!Array.prototype.clone) {
  Array.prototype.clone = function clone() {
    return JSON.parse(JSON.stringify(this));
  };
}
